
import BaseSpinner from "@/components/base/BaseSpinner.vue";
import { AmendmentOptionTypeEnum, CancellationTypeEnum } from "@/models/enums";
import { amendmentDialogKey, AmendmentOptions } from "@/models/symbols/Amendment";
import { useEventBus } from "@vueuse/core";
import { defineComponent, ref } from "vue";
import { useI18n } from "vue-i18n";

export default defineComponent({
	components: {
		BaseSpinner,
	},
	setup() {
		const bus = useEventBus(amendmentDialogKey);
		const { t } = useI18n();
		const show = ref(false);
		const loading = ref<boolean>(false);
		const data = ref<AmendmentOptions>();

		const options = [
			{
				number: 1,
				type: AmendmentOptionTypeEnum.Edit,
				name: t("account.bookings.amendment.options.tripDetails"),
			},
			{
				number: 2,
				type: AmendmentOptionTypeEnum.Edit,
				name: t("account.bookings.amendment.options.departures"),
			},
			{
				number: 3,
				type: AmendmentOptionTypeEnum.Edit,
				name: t("account.bookings.amendment.options.extras"),
			},
			{
				number: 4,
				type: AmendmentOptionTypeEnum.Edit,
				name: t("account.bookings.amendment.options.passengerDetails"),
			},
			{
				number: 5,
				type: AmendmentOptionTypeEnum.Edit,
				name: t("account.bookings.amendment.options.checkout"),
			},
			{
				number: 6,
				type: AmendmentOptionTypeEnum.CancelOutward,
				name: t("account.bookings.amendment.options.cancelOutward")
			},
			{
				number: 7,
				type: AmendmentOptionTypeEnum.CancelReturn,
				name: t("account.bookings.amendment.options.cancelReturn")
			}
		]

		const filteredOptions = options.filter((option) => option.number < 6);
		const disableOption = (type: AmendmentOptionTypeEnum) => {
			if(!data.value?.isEditable && type === AmendmentOptionTypeEnum.Edit){
				return true;
			}
			else if(type === AmendmentOptionTypeEnum.CancelOutward && 
					(((data.value?.booking.cancellationType ?? 0) & CancellationTypeEnum.Outward)) == 0) {
					
				return true;
			}
			else if(type === AmendmentOptionTypeEnum.CancelReturn && 
			(((data.value?.booking.cancellationType ?? 0) & CancellationTypeEnum.Return)) == 0) {
							
				return true;
			}
			else {
				return false;
			}
		};

		const redirect = (step: number, type: AmendmentOptionTypeEnum) => {
			loading.value = true;

			if(data.value?.callback) {
				data.value.callback(step, type)
				.finally(() => {
					show.value = false;
					loading.value = false;
				});
			}			
		}

		bus.on((e) => {
			show.value = true;
			data.value = e;
		});

		const overlayClicked = (e: any) => {
			e.preventDefault();
			show.value = false;
		};

		return {
			show,
			data,
			overlayClicked,
			redirect,
			loading,
			disableOption,
			options,
			filteredOptions
		};
	},
});
